export default __webpack_public_path__ + "cedb3494a22fa6c964664f47a62ce053.woff2";